<template>
  <div class="center">
    <!--弹窗-->
    <div class="toast-bg" v-show="loadingFlag">
      <div class="toast-me middle toast-me2">
        <img src="../assets/img/loading.gif" alt="" />
      </div>
    </div>
    <!--弹窗-->
    <div class="toast-bg" v-show="detailFlag">
      <div class="toast-me middle">
        <div class="toast-tit">您的预约登记已成功</div>
        <hr class="toast-line" />
        <div class="toast-main toast-main2">
          <div class="toast-text">您的预约登记号为：{{ RegisNumber }}</div>
          <div class="toast-text">
            为您提供的服务是：
            <span class="toast-blue-span">{{ serviceSiteName }}</span>,联系电话：
            <span class="toast-blue-span">{{ serviceTelephone }}</span>
          </div>
        </div>
        <div class="toast-main toast-main2">
          <div>
            <img class="qrcode-img" :src="successQrCodeUrl" />
          </div>
          <div class="toast-text">
            扫码关注「索尼中国 售后服务」微信公众号，及时获取服务进度及更多资讯。
          </div>
        </div>
        <div class="question-btns" style="background: none">
          <a href="javascript:" class="submit-btn" @click="detailFlag = false">点击关闭</a>
        </div>
      </div>
    </div>
    <div class="main-wrap">
      <div class="detail-page-nav">
        <a href="javascript:">首页
          <i> &gt; </i>
        </a>
        <a href="javascript:">在线预约及查询
          <i> &gt; </i>
        </a>
        <a href="javascript:" class="active">预约上门</a>
      </div>
      <div class="banner"><img src="../assets/img/home.png" alt="" /></div>
      <div class="mainContent">
        <div class="show-part">
          <div class="reservation-category">请选择预约类别</div>
          <div class="products" style="display: flex">
            <span style="width: 130px;">产品类别：</span>
            <div>
              <a href="javascript:" :class="[{ active: index === productIndex }]"
                @click="selectProduct(index, item.type, item.category)" v-for="(item, index) in productTypes"
                :key="index">{{ item.name }}</a>
            </div>
          </div>
          <div class="products" style="display: flex">
            <span style="width: 111px;">服务内容：</span>
            <div>
              <a href="javascript:" :class="[{ active: index === serviceIndex }]" @click="selectService(index, item)"
                v-for="(item, index) in serviceType" :key="index">{{ item.name }}</a>
            </div>
          </div>
          <div class="a-groups">
            <div :class="['agree', { check2: checkA }]" @click="checkFun"></div>
            <!-- 20210720_update -->
            <!-- <a href="https://www.sony.com.cn/privacy/terms.html" target="_blank" class="download-a">您已经了解《索尼产品顾客个人信息隐私政策》</a> -->
            <a href="https://www.sony.com.cn/privacy/terms.html" target="_blank" class="download-a">本人已了解同意《索尼隐私政策》</a>
            <a href="https://service.sony.com.cn/service/installation/index.html" target="_blank" class="download-a"
              style="margin-left: 37px">点击了解电视机 【索尼官方专业安装】详情</a>
            <a v-if="false" href="https://service.sony.com.cn/service/yaokongqi2/index.html" target="_blank"
              class="download-a" style="margin-left: 37px">点击了解【遥控器省心寄修服务】详情</a>
          </div>
        </div>
      </div>
      <div class="hide-part" v-if="
        formPart &&
        !isPickUp && productIndex != null
      ">
        <div class="mainContent">
          <div class="reservation-category">请填写个人信息</div>
          <div class="input-groups">
            <div class="select-item clearfix">
              <div class="fl item-left">
                <span class="star">*</span>
                <span class="item-label">个人地址：</span>
              </div>
              <div class="item-right fl">
                <div class="select-wrap select-wrap2">
                  <select name="" v-model="provinceCode" style="margin-right: 20px" @change="selectProvince()">
                    <option disabled value="default">请选择省</option>
                    <option :value="item.provinceid" v-for="(item, index) in proviceList" :key="index">
                      {{ item.name }}
                    </option>
                  </select>
                  <select name="" v-model="cityCode" style="margin-right: 20px" @change="selectCity()">
                    <option disabled value="default">请选择市</option>
                    <option :value="item.cityid" v-for="(item, index) in cityList" :key="index">
                      {{ item.name }}
                    </option>
                  </select>
                  <select name="" v-model="districtCode" @change="selectDistrict()" style="margin-right: 20px">
                    <option disabled value="default">请选择区</option>
                    <option :value="item.areaid" v-for="(item, index) in districList" :key="index">
                      {{ item.name }}
                    </option>
                  </select>

                  <select name="" v-model="townCode" @change="getAsc()">
                    <option disabled value="default">请选择乡镇</option>
                    <option :value="item.townid" v-for="(item, index) in townList" :key="index">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class="item-two">
                  <input type="text" placeholder="详细地址" class="detail-addr" v-model="detailAddr" regType="ifVal"
                    maxlength="50" />
                </div>
              </div>
            </div>
            <div class="select-item clearfix">
              <div class="fl item-left">
                <span class="star">*</span>
                <span class="item-label">维修站：</span>
              </div>
              <div class="item-right fl">
                <div class="select-wrap clearfix">
                  <select name="" v-model="serviceSite" @change="getSite()" style="width: 300px">
                    <option disabled value="default">请选择维修站</option>
                    <option :value="item.ascid" v-for="(item, index) in ASCList" :key="index">
                      {{ item.ascmame }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="select-item clearfix">
              <div class="fl item-left">
                <span class="star">*</span>
                <span class="item-label">您的姓名：</span>
              </div>
              <div class="item-right fl">
                <input type="text" class="name-input" v-model="name" ref="name" />
              </div>
              <div class="gender fl" v-for="(item, index) in genderList" :key="index">
                <a href="javascript:" @click="radioSelect(item.sex, index)">
                  <span :class="['little-dot', { active: misterFlag === index }]"></span>
                </a>
                <span class="gender-span">{{ item.name }}</span>
              </div>
            </div>
            <div class="select-item clearfix">
              <div class="fl item-left">
                <span class="star">*</span>
                <span class="item-label">验证码：</span>
              </div>
              <div class="item-left verification-input fl">
                <input type="text" class="name-input" v-model="verificationNum" ref="verificationNum" />
                <img :src="imgsrc" alt="" @click="refreshImg" />
              </div>
              <!--<div class="item-right verification-input fl">-->
              <!--<input type="text" class="name-input" />-->
              <!--<img src="../assets/img/code-img.png" alt="" />-->
              <!--</div>-->
            </div>
            <div class="select-item clearfix">
              <div class="fl item-left">
                <span class="star">*</span>
                <span class="item-label">手机：</span>
              </div>
              <div class="item-right fl">
                <input type="text" class="number-input" v-model="mobile" ref="mobile" />
              </div>
              <div class="item-right fl">
                <span class="text">电话：</span>
                <input type="text" class="tele-input1" />
                <span class="short-line"></span>
                <input type="text" class="tele-input2" />
              </div>
            </div>
            <div class="select-item clearfix">
              <div class="fl item-left">
                <span class="star">*</span>
                <span class="item-label">短信验证码：</span>
              </div>
              <div class="item-right fl">
                <input class="number-input" v-model="smsCode" ref="mobile" />
              </div>
              <div class="item-right fl">
                <div :class="[phoneVerFlag ? 'vercode_disable' : 'vercode']" @click="getPhoneVerif">
                  {{ phoneVerMessage }}
                </div>
              </div>
            </div>
            <div class="select-item clearfix">
              <div class="fl item-left">
                <span class="star"></span>
                <span class="item-label">邮箱：</span>
              </div>
              <div class="item-right fl">
                <input type="text" class="number-input" v-model="email" />
              </div>
            </div>
          </div>
          <div class="reservation-info">
            <div class="reservation-category">请填写预约信息</div>
            <div class="input-groups">
              <div class="select-item clearfix">
                <div class="fl item-left">
                  <span class="star">*</span>
                  <span class="item-label">上门时间：</span>
                </div>
                <div class="item-right fl" style="width: 1006px">
                  <div class="products products-week" style="margin-bottom: 0">
                    <a href="javascript:" :class="{ active: weekIndex === index }"
                      @click="seletWeekDay(index, item.year)" v-for="(item, index) in weekList" :key="index">{{
                        item.year }}<br />{{ item.week }}</a>
                  </div>
                  <div class="period">
                    <div class="period-img">
                      <img src="../assets/img/gray-sanjiao.png" alt="" />
                    </div>
                    <div class="period-box">
                      <div class="period-bg clearfix">
                        <div class="day-wrap">
                          <span :class="{ active: dayIndex === index }" v-for="(item, index) in oneDayList" :key="index"
                            @click="selectDay(index)">{{ item.tit }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="select-item clearfix">
                <div class="fl item-left">
                  <span class="star">*</span>
                  <span class="item-label">产品型号：</span>
                </div>
                <div class="item-right fl" style="position: relative">
                  <input type="text" class="number-input" v-model="modelCode" @keyup="modelCodeFun" @blur="checkDI" />
                  <div class="reg-product" @click="handleRegProduct">+ 选择已注册产品</div>
                  <ul class="ul-menu ul-menu-home" v-show="regProductFlag">
                    <li v-for="(item, index) in regProductDataList"
                      @click="selectRegPorduct(item.productModel, item.serialNumber)" :key="index">
                      {{ item.productModel }}（序列号：{{ item.serialNumber }}）
                    </li>
                  </ul>
                  <div class="serial-number-a">
                    服务收费标准请点击
                    <a target="_blank"
                      href="https://service.sony.com.cn/content/casch/serviceinfo/servicepolicy.html?tab=chargestand">这里</a>
                  </div>
                  <ul class="ul-menu ul-menu-home" v-show="modelulFlag">
                    <li v-for="(item, index) in modeList" @click="selectMode(item.enName)" :key="index">
                      {{ item.enName }}
                    </li>
                  </ul>
                </div>
                <div class="fl item-left">
                  &nbsp; &nbsp; &nbsp;
                  <!-- <span class="star">*</span> -->
                  <span class="item-label">序列号：</span>
                </div>
                <div class="item-right fl">
                  <input type="text" class="number-input" v-model="serialNum" />
                  <div class="serial-number-a">
                    查询产品型号和序列号确认方法请点击
                    <a target="_blank" href="https://www.sony.com/zh-cn/electronics/support/articles/00184953">这里</a>
                  </div>
                </div>
              </div>
              <div class="select-item clearfix">
                <div class="fl item-left">
                  <span class="star"></span>
                  <span class="item-label">购机日期：</span>
                </div>
                <div class="item-right fl">
                  <DatePicker type="date" @on-change="buyDate = $event" :options="optionsDis1" :value="buyDate"
                    placeholder="购机日期" style="width: 200px"></DatePicker>
                </div>
              </div>
              <div class="select-item clearfix">
                <div class="fl item-left" style="line-height: 44px">
                  <span class="star">*</span>
                  <span class="item-label">保修类型：</span>
                </div>
                <div class="products products2 item-right fl">
                  <a href="javascript:" :class="{ active: warrantIndex === index }"
                    v-for="(item, index) in warrantyList" @click="warrantCheck(index, item.code)" :key="index">{{
                      item.name }}</a>
                </div>
                <div class="item-right fl Terms">
                  <span>维修站将基于事实和相关 <br />法律法规作出最终判断</span>
                  <a target="_blank"
                    href="https://service.sony.com.cn/content/casch/serviceinfo/servicepolicy.html">产品保修条款</a>
                </div>
              </div>
              <div class="select-item clearfix">
                <div class="fl item-left" style="line-height: normal">
                  <span class="item-label">购机发票({{ billFileList.length }}/{{
                    billFileCount
                  }})：</span>
                </div>
                <div class="item-left verification-input fl" style="margin-top: -20px">
                  <el-upload ref="upload_bill" :action="getUploadUrl()" :auto-upload="true" list-type="picture"
                    :limit="billFileCount" :before-upload="beforeUploadBill" :on-success="uploadBillSuccess"
                    :on-remove="removeBill" accept=".jpg,.png,.pdf">
                    <div class="question-btns" style="margin-left: 20px; background: #ffffff; height: 0">
                      <a href="javascript:" class="submit-btn">选择文件</a>
                    </div>
                  </el-upload>
                </div>
              </div>
              <div class="select-item clearfix">
                <div class="fl item-left" style="line-height: normal">
                  <span class="item-label">保修卡({{ cardFileList.length }}/{{
                    cardFileCount
                  }})：</span>
                </div>
                <div class="item-left verification-input fl" style="margin-top: -20px">
                  <el-upload ref="upload_card" :action="getUploadUrl()" :auto-upload="true" list-type="picture"
                    :limit="cardFileCount" :before-upload="beforeUploadCard" :on-success="uploadCardSuccess"
                    :on-remove="removeCard" accept=".jpg,.png,.pdf">
                    <div class="question-btns" style="margin-left: 20px; background: #ffffff; height: 0">
                      <a href="javascript:" class="submit-btn">选择文件</a>
                    </div>
                  </el-upload>
                </div>
              </div>
              <div class="select-item clearfix">
                <div class="fl item-left" style="line-height: normal">
                  <span class="star">*</span>
                  <span class="item-label">服务要求/ 症状描述：</span>
                </div>
                <div class="item-right fl textarea-wrap">
                  <textarea name="" id="" cols="" rows="" v-model="trouble">
                  </textarea>
                </div>
              </div>
              <div class="select-item clearfix">
                <div class="fl item-left" style="line-height: normal">
                  <span class="item-label">症状照片({{ problemFileList.length }}/{{
                    problemFileCount
                  }})：</span>
                </div>
                <div class="item-left verification-input fl" style="margin-top: -20px">
                  <el-upload ref="upload_problem" :action="getUploadUrl()" :auto-upload="true" list-type="picture"
                    :multiple="true" :limit="problemFileCount" :before-upload="beforeUploadProblem"
                    :on-success="uploadProblemSuccess" :on-remove="removeProblem" accept=".jpg,.png,.pdf">
                    <div class="question-btns" style="margin-left: 20px; background: #ffffff; height: 0">
                      <a href="javascript:" class="submit-btn">选择文件</a>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="notice">
              <div class="notice_tit fl">注意事项</div>
              <div class="notice-list">
                <ul>
                  <li>
                    ●
                    您的预约登记成功后，维修站会及时处理您的预约单，并与您联系以确认上门时间，请确保您提供的电话保持畅通。
                  </li>
                  <li>
                    ● 由于需要事先安排，目前维修站只接受14天内的服务预约。
                  </li>
                  <li>
                    ●
                    如您需要更改信息或期望上门日期，请提前联系上面显示的维修站电话号码。
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="question-btns">
          <a href="javascript:" class="back-btn" @click="resetData">重置</a>
          <a href="javascript:" class="submit-btn" @click="addQuery">提交</a>
        </div>
      </div>
      <pick-up v-if="formPart && isPickUp && productIndex != null" :productType="productType"
        :productIndex="productIndex" :serviceType="serviceType" :repairPropertie="repairPropertie"
        :reserveReason="reserveReason" :serviceIndex="serviceIndex"></pick-up>
    </div>

    <systemNotice></systemNotice>
    <login></login>
  </div>
</template>
<script>
// @ is an alias to /src
import login from "../components/login"
import systemNotice from "../components/system-notice"
import api from "../common/utils/api";
import { JSEncrypt } from "jsencrypt";
import {
  getDay,
  sevenDays,
  getCode,
  regs,
  isMobileDevice,
  Condition,
  sevenDaysPickUp,
} from "../common/utils/pageCtents";
import http from "axios";
import pickUp from "@/views/pick-up";
let dayInit = getDay(2, "-", new Date());
console.log("dayInit:", dayInit);
// 液晶电视-液晶电视底座安装：T   液晶电视-液晶电视挂墙安装：I  液晶电视-维修：S   液晶电视-调试：T
export default {
  components: {
    pickUp: pickUp,
    systemNotice: systemNotice,
    login: login
  },
  data() {
    return {
      optionsDis1: {
        disabledDate(date) {
          return date.getTime() > new Date().getTime();
        }
      },
      serviceTelephone: "",
      PUBLIC_KEY:
        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCLwK1xP5uTgoJshPCtJxVuTq36JIh05HBsfGshE71oR9syteqAJcupa76O+dm9cI3iCiMHGdo7mhqAt/haiVrBHOamxe5OYaAK06waKMBct+O2SC1F6dY7voIA0PPw0DSnTD1FIHslwmw1ccB0/c9Hr5ytQ9n3BGUlRRrSZJKAZQIDAQAB",
      uploadUrl: api.reservation.uploadFile(),
      loadingFlag: false,
      serviceSiteName: "",
      RegisNumber: "",
      detailFlag: false,
      reservationCheck: true,
      oneDayList: [
        {
          tit: "上午",
          id: 0,
        },
        {
          tit: "下午",
          id: 1,
        },
      ],
      genderList: [
        {
          name: "先生",
          sex: "sir",
        },
        {
          name: "女士",
          sex: "lady",
        },
      ],
      trouble: "",
      imgsrc: "",
      verificationNum: "",
      weekIndex: null,
      dayIndex: null,
      misterFlag: null,
      checkA: false,
      formPart: false,
      productIndex: null,
      serviceIndex: null,
      reserveType: "H",
      productType: "",
      productTypes: [
        {
          name: "液晶电视",
          type: "B",
          serviceCategory: "0",
          category: "tv"
        },
        {
          name: "家庭影院",
          type: "H",
          serviceCategory: "1",
          category: "audio"
        },
        {
          name: "INZONE（显示器）",
          type: "B",
          serviceCategory: "0",
          category: "tv"
        },
        {
          name: "INZONE（键盘、鼠标）",
          type: "E",
          serviceCategory: "2",
          category: ""
        },
        {
          name: "数码类产品（照相机、音频、手机）",
          type: "E",
          serviceCategory: "2",
          category: ""
        },
        {
          name: "电视遥控器",
          type: "B",
          serviceCategory: "0",
          category: "tv"
        },
        {
          name: "商用显示器",
          type: "B",
          serviceCategory: "0",
          category: "stv"
        },
        {
          name: "游戏机及周边配件",
          type: "7",
          serviceCategory: "2",
          category: "game"
        },
      ],
      
      repairProperties: "",
      reserveReason: "",
      serviceType: [],
      // 液晶电视
      serviceType1: [
        {
          name: "底座安装",
          reasonCode: "94",
          properties: "T",
          isPickUp: false
        },
        {
          name: "挂墙安装",
          reasonCode: "95",
          properties: "I",
          isPickUp: false
        },
        {
          name: "调试",
          reasonCode: "99",
          properties: "T",
          isPickUp: false
        },
        {
          name: "维修",
          reasonCode: "96",
          properties: "S",
          isPickUp: false
        },
      ],
      // 家庭影院
      serviceType2: [
        {
          name: "维修",
          reasonCode: "110",
          properties: "",
          isPickUp: false
        },
        {
          name: "底座安装",
          reasonCode: "108",
          properties: "",
          isPickUp: false
        },
        {
          name: "挂墙安装",
          reasonCode: "1000000072",
          properties: "",
          isPickUp: false
        },
      ],
      // 电竞显示器
      serviceType3: [
        {
          name: "电竞显示器上门维修",
          reasonCode: "1000000082",
          properties: "",
          isPickUp: false
        },
      ],
      //电竞键盘鼠标
      serviceType4: [
        {
          name: "电竞键盘鼠标上门取件服务",
          reasonCode: "1000000081",
          properties: "",
          isPickUp: true
        },
      ],
      // 数码产品
      serviceType5: [
        {
          name: "上门取件服务",
          reasonCode: "11330",
          properties: "",
          isPickUp: true
        },
        {
          name: "传感器清洁",
          reasonCode: "1000000076",
          properties: "",
          isPickUp: true
        },
        {
          name: "校准服务",
          reasonCode: "1000000077",
          properties: "",
          isPickUp: true
        },
      ],
      // 电视遥控器
      serviceType6: [
        {
          name: "非保修/遗失换新",
          reasonCode: "11329",
          properties: "",
          isPickUp: false //遗失换新不需要触发上门取件
        },
        {
          name: "保修内故障更换",
          reasonCode: "11329",
          properties: "",
          isPickUp: true //维修更换需要触发上门取件
        }
      ],
      // 商用显示器
      serviceType7: [
        {
          name: "底座安装",
          reasonCode: "94",
          properties: "T",
          isPickUp: false
        },
        {
          name: "挂墙安装",
          reasonCode: "95",
          properties: "I",
          isPickUp: false
        },
        {
          name: "调试",
          reasonCode: "99",
          properties: "T",
          isPickUp: false
        },
        {
          name: "维修",
          reasonCode: "96",
          properties: "S",
          isPickUp: false
        },
      ],
      // 游戏周边设备
      serviceType8: [
        {
          name: "上门取件服务",
          reasonCode: "1000000070",
          properties: "",
          isPickUp: true
        },
      ],

      SelectData: {},
      proviceList: [],
      cityList: [],
      districList: [],
      townList: [],
      selectIndex: null,
      provinceCode: "default",
      cityCode: "default",
      districtCode: "default",
      townCode: "default",
      serviceSite: "default",
      serviceFlag2: false,
      selectUL: true,
      cityUrl: "",
      districUrl: "",
      ASCList: [],
      weekList: [],
      morningList: [
        {
          showTime: "08:00-08:30",
          time: `${dayInit} 08:00:00`,
        },
        {
          showTime: "08:30-09:00",
          time: `${dayInit} 08:30:00`,
        },
        {
          showTime: "09:00-09:30",
          time: `${dayInit} 09:00:00`,
        },
        {
          showTime: "09:30-10:00",
          time: `${dayInit} 09:30:00`,
        },
        {
          showTime: "10:00-10:30",
          time: `${dayInit} 10:00:00`,
        },
        {
          showTime: "10:30-11:00",
          time: `${dayInit} 10:30:00`,
        },
        {
          showTime: "11:00-11:30",
          time: `${dayInit} 11:00:00`,
        },
        {
          showTime: "11:30-12:00",
          time: `${dayInit} 11:30:00`,
        },
      ],
      afterList: [
        {
          showTime: "13:00-13:30",
          time: `${dayInit} 13:00:00`,
        },
        {
          showTime: "13:30-14:00",
          time: `${dayInit} 13:30:00`,
        },
        {
          showTime: "14:00-14:30",
          time: `${dayInit} 14:00:00`,
        },
        {
          showTime: "14:30-15:00",
          time: `${dayInit} 14:30:00`,
        },
        {
          showTime: "15:00-15:30",
          time: `${dayInit} 15:00:00`,
        },
        {
          showTime: "15:30-16:00",
          time: `${dayInit} 15:30:00`,
        },
        {
          showTime: "16:00-16:30",
          time: `${dayInit} 16:00:00`,
        },
        {
          showTime: "16:30-17:00",
          time: `${dayInit} 16:30:00`,
        },
        {
          showTime: "17:00-17:30",
          time: `${dayInit} 17:00:00`,
        },
        {
          showTime: "17:30-18:00",
          time: `${dayInit} 17:30:00`,
        },
        {
          showTime: "18:00-18:30",
          time: `${dayInit} 18:00:00`,
        },
        {
          showTime: "18:30-19:00",
          time: `${dayInit} 18:30:00`,
        },
        {
          showTime: "19:00-19:30",
          time: `${dayInit} 19:00:00`,
        },
        {
          showTime: "19:30-20:00",
          time: `${dayInit} 19:30:00`,
        },
        {
          showTime: "20:00-20:30",
          time: `${dayInit} 20:00:00`,
        },
        {
          showTime: "20:30-21:00",
          time: `${dayInit} 20:30:00`,
        },
        // {
        //   showTime: '21:00-21:30',
        //   time: `${dayInit} 21:00:00`
        // },
        // {
        //   showTime: '21:30-22:00',
        //   time: `${dayInit} 21:30:00`
        // }
      ],
      warrantyType: "",
      warrantyList: [
        {
          name: "保外",
          code: "O",
          id: 2,
        },
        {
          name: "保内",
          code: "I",
          id: 1,
        },
        {
          name: "延保",
          code: "E",
          id: 3,
        },
      ],
      warrantIndex: null,
      // 提交预约的字段
      detailAddr: "",
      ASCCode: "",
      name: "",
      email: "",
      mobile: "",
      customerReserveDate: "",
      reserveDateRange: "", // A(上午) P（下午），
      gender: "",
      serialNum: "",
      modelCode: "",
      modeList: [],
      modelulFlag: false,
      buyDate: "",
      conditionFlag: "",
      billFileList: [],
      cardFileList: [],
      problemFileList: [],
      billFileCount: 1, //发票附件可选择数
      cardFileCount: 1, //保卡附件可选择数
      problemFileCount: 2, //症状附件可选择数
      phoneVerMessage: "获取验证码", //获取验证码描述
      phoneTime: 60, //验证码多久可以再次获取 默认60s
      phoneVerFlag: false, // 获取验证码状态
      smsCode: "", //短信验证码
      successQrCodeUrl: require("../assets/img/202305220001_1280_toHome.jpg"), //预约成功后展示的二维码
      regProductDataList: [], //已注册产品列表
      regProductFlag: false, //是否展示已注册产品列表
      productCategory: "", //产品类别 用于输入的产品型号校验
      isPickUp: false, //判断是否是上门取件
      isChoosedModel: false // 是否选择了下拉框中的产品型号
    };
  },

  methods: {
    /**
     * 拼接附件上传地址
     * 拼接维修站编号是为了对接HiCis接口试运行，需要根据维修站后端走不同接口，等HiCis正式上线的时候，该逻辑可以取消
     */
    getUploadUrl() {
      if (this.serviceSite === "" || this.serviceSite === "default") {
        return "";
      }
      return this.uploadUrl + "/" + this.serviceSite;
    },

    resetData() {
      this.verificationNum = "";
      this.detailAddr = "";
      this.modeSpread = false;
      this.modelulFlag = false;
      this.gender = null;
      this.name = "";
      this.email = "";
      this.mobile = "";
      this.reserveReason = "";
      this.customerReserveDate = "";
      this.reserveDateRange = "";
      this.modelCode = "";
      this.buyDate = "";
      this.serialNum = "";
      this.trouble = "";
      this.warrantyType = "";
      this.productType = "";
      this.repairPropertie = "";
      this.provinceCode = "default";
      this.cityCode = "default";
      this.serviceSite = "default";
      this.weekIndex = null;
      this.misterFlag = null;
      this.productIndex = null;
      this.serviceIndex = null;
      this.selectIndex = null;
      this.warrantIndex = null;
      this.dayIndex = null;
      this.$refs.upload_bill.clearFiles();
      this.$refs.upload_card.clearFiles();
      this.$refs.upload_problem.clearFiles();
      this.isChoosedModel = false;
    },
    /**
     * 获取短信验证码
     */
    getPhoneVerif() {
      if (this.phoneVerFlag) {
        return;
      }
      var phoneReg = /^[1][3,4,5,7,8,9][0-9]{9}$/;

      this.phoneVerFlag = true;
      if (this.verificationNum === "") {
        this.showModel("请填写图形验证码");
        this.phoneVerFlag = false;
        return;
      }
      if (this.mobile === "") {
        this.showModel("请输入手机号");
        this.phoneVerFlag = false;
        return;
      }
      if (!phoneReg.test(this.mobile)) {
        this.showModel("请输入正确的手机号");
        this.phoneVerFlag = false;
        return;
      }
      if (this.serviceSite === "default") {
        this.showModel("请选择维修站");
        this.phoneVerFlag = false;
        return;
      }
      //数据加密
      let timeStamp = new Date().getTime();
      let url = api.reservation.getSmsCode();
      let encryptor = new JSEncrypt();
      encryptor.setPublicKey(
        "-----BEGIN PUBLIC KEY-----" +
        this.PUBLIC_KEY +
        "-----END PUBLIC KEY-----"
      );
      var encrypted = encryptor.encrypt(this.mobile + "," + timeStamp);
      console.log("加密后数据:%o", encrypted);
      let data = {
        mobile: this.mobile,
        timeStamp: timeStamp,
        vaildCode: this.verificationNum,
        cipher: encrypted,
        organizationCode: this.serviceSite,
      };
      http.post(url, data).then((res) => {
        if (res.data.stateCode !== 1) {
          this.showModel(res.data.message);
          this.phoneVerFlag = false;
        } else {
          this.showModel("发送成功");
          this.times();
        }
      });
    },
    /**
     * 倒计时功能
     */
    times() {
      //开启倒计时
      this.timer = setInterval(() => {
        this.phoneTime--;
        this.phoneVerMessage = this.phoneTime + "s后可以重新获取";
        if (this.phoneTime === 0) {
          clearInterval(this.timer);
          this.phoneVerMessage = "获取验证码";
          this.phoneTime = 60;
          this.phoneVerFlag = false;
        }
      }, 1000);
    },
    // 产品型号的模糊查询
    modelCodeFun() {
      this.isChoosedModel = false;
      this.modeSpread = false;
      let url = api.reservation.findProModel();
      let keyword = "" + this.modelCode.trim().toUpperCase();
      // 231207add 商用显示器不进行产品型号模糊查询
      if (keyword.length > 1 && this.productCategory != 'stv') {
        http({
          method: "GET",
          url: url,
          params: {
            keyword: keyword,
          },
        })
          .then((res) => {
            this.modeList = res.data.returnData.Data;
            if (this.modeList && this.modeList.length) {
              this.modelulFlag = true;
            } else {
              this.modelulFlag = false;
              let returnMsg = res.data.returnMsg;
              this.$toast({
                show: true,
                message: returnMsg,
                position: "top",
                during: 3000,
              });
            }
            console.log("产品型号：", res);
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    async hicisProductCheck(modelCode) {
      let url = api.reservation.getCheckDI();
      await http({
        method: "POST",
        url: url,
        data: {
          modelCode: modelCode,
          serviceItem: this.reserveReason
        },
      })
        .then((res) => {
          if (res.data.data != 1) {
            this.modelCode = "";
            this.$toast({
              show: true,
              message: "本型号暂未开通该预约服务项目,不允许继续填入及提交",
              position: "top",
              during: 3000,
            });
          }
          this.modelulFlag = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async selectMode(mode) {
      this.modelCode = mode;
      this.isChoosedModel = true;
      // 添加逻辑：电竞显示器上门维修 需要通过checkDI接口校验
      if (this.reserveReason === "1000000082") {
        await this.hicisProductCheck(mode)
        return
      }
      this.checkProductTypeAndCode(mode, result => {
        if (!result) {
          this.modelCode = "";
          this.$toast({
            show: true,
            message: this.productCategory === "tv" ? "请输入电视机型号" : "输入的产品型号与产品类别不匹配",
            position: "top",
            during: 3000,
          });
          return
        } else {
          this.modelCode = mode;
          this.modelulFlag = false;
        }
      });
    },
    //DI品类的check
    checkDI() {
      // blur方法会在选择产品型号方法前面执行，所以这里进行下延迟判断
      setTimeout(() => {
        // 231207add 商显必须 FW- 开头录入
        if (this.productCategory == 'stv') {
          if (this.modelCode != '' && this.modelCode.substring(0, 3) != 'FW-') {
            this.modelCode = "";
            this.$toast({
              show: true,
              message: "请输入FW-开头的产品型号",
              position: "top",
              during: 3000,
            });
            return;
          }
        }

        // 如果产品型号有值 || 选择了下拉框中的产品型号 不进行blur后的check(选择下拉框已经会check一次)
        if (!this.modelCode || this.isChoosedModel) {
          return;
        }
        let mode = this.modelCode;
        this.checkProductTypeAndCode(mode, result => {
          if (!result) {
            this.modelCode = "";
            this.$toast({
              show: true,
              message: this.productCategory === "tv" ? "请输入电视机型号" : "输入的产品型号与产品类别不匹配",
              position: "top",
              during: 3000,
            });
          }
        })
      }, 300);
    },
    checkSingle(value, type) {
      let reg = new RegExp(regs[type]);
      if (!reg.test(value)) {
        return false;
      }
      return true;
    },
    checkSpace(item) {
      if (!item.val) {
        this.showModel(item.message);
        return false;
      } else {
        let newVal = (item.val + "").trim();
        if (item.reg) {
          if (!this.checkSingle(newVal, item.reg)) {
            this.showModel(item.message);
            return false;
          }
        } else {
          if (!newVal) {
            this.showModel(item.message);
            return false;
          }
        }
      }
      return true;
    },
    showModel(mes) {
      this.$toast({
        show: true,
        message: mes,
        position: "top",
        during: 3000,
      });
    },
    checkInput() {
      // 上门地址
      if (this.serviceSite === "default") {
        if (
          this.provinceCode === "default" ||
          this.cityCode === "default" ||
          this.districtCode === "default"
        ) {
          this.showModel("请选择上门地址！");
        } else {
          this.showModel("该地址没有维修站，请重新选择！");
        }
        return false;
      }
      // 详细check
      let checkDatas = [
        {
          val: this.detailAddr,
          message: "请填写详细地址！",
        },
        {
          val: this.name,
          message: "请填写姓名！",
        },
        {
          val: this.gender,
          message: "请填写您的性别！",
        },
        {
          val: this.mobile,
          message: "请填正确的手机号！",
          reg: "telPhone",
        },
        {
          val: this.customerReserveDate,
          message: "请填选择预约日期！",
        },
        {
          val: this.reserveDateRange,
          message: "请填选择预约时段！",
        },
        {
          val: this.modelCode,
          message: "请填写产品型号！",
        },
        // {
        //   val: this.serialNum,
        //   message: '请填写产品序列号！'
        // },
        {
          val: this.buyDate,
          message: "请选择购机日期！",
        },
        {
          val: this.warrantyType,
          message: "请选择保修类型！",
        },
        {
          val: this.trouble,
          message: "请填写服务要求或症状描述！",
        },
        {
          val: this.verificationNum,
          message: "请填写图片验证码！",
        },
        {
          val: this.smsCode,
          message: "请填写短信验证码！",
        },
      ];
      for (let index in checkDatas) {
        if (!this.checkSpace(checkDatas[index])) {
          console.log("checkDatas[index]", checkDatas[index]);
          return false;
        }
      }
      // checkDatas.forEach((currentValue) => {
      //   console.log(this.checkSpace(currentValue))
      //
      // })
      return true;
    },
    /**
     * 上传发票附件验证
     */
    beforeUploadBill(file) {
      const isLt20M = file.size / 1024 / 1024 < 10;
      var fileSrc = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isPDF = fileSrc === "pdf";
      const isImg =
        fileSrc === "jpg" ||
        fileSrc === "png" ||
        fileSrc === "jpeg" ||
        fileSrc === "JPG" ||
        fileSrc === "PNG" ||
        fileSrc === "JPEG";
      if (!isLt20M) {
        this.showModel("发票附件大小不能超过10MB");
      }
      if (!isPDF && !isImg) {
        this.showModel("只能上传pdf，jpg，png, jpeg格式");
      }
      return isLt20M && (isPDF || isImg);
    },
    /**
     * 发票上传成功处理
     */
    uploadBillSuccess(response, file, fileList) {
      let data = {
        file: file,
        id: response.data.id,
      };
      this.billFileList = this.billFileList.concat(data);
    },

    /**
     * 发票附件移除
     */
    removeBill(file, fileList) {
      for (let i = 0; i < this.billFileList.length; i++) {
        if (this.billFileList[i].file.uid == file.uid) {
          this.billFileList.splice(i, 1);
        }
      }
    },

    /**
     * 上传保卡附件验证
     */
    beforeUploadCard(file) {
      const isLt20M = file.size / 1024 / 1024 < 10;
      var fileSrc = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isPDF = fileSrc === "pdf";
      const isImg =
        fileSrc === "jpg" ||
        fileSrc === "png" ||
        fileSrc === "jpeg" ||
        fileSrc === "JPG" ||
        fileSrc === "PNG" ||
        fileSrc === "JPEG";
      if (!isLt20M) {
        this.showModel("保卡附件大小不能超过10MB");
      }
      if (!isPDF && !isImg) {
        this.showModel("只能上传pdf，jpg，png, jpeg格式");
      }
      return isLt20M && (isPDF || isImg);
    },
    /**
     * 保卡上传成功处理
     */
    uploadCardSuccess(response, file, fileList) {
      let data = {
        file: file,
        id: response.data.id,
      };
      this.cardFileList = this.cardFileList.concat(data);
    },
    /**
     * 保卡附件移除
     */
    removeCard(file, fileList) {
      for (let i = 0; i < this.cardFileList.length; i++) {
        if (this.cardFileList[i].file.uid == file.uid) {
          this.cardFileList.splice(i, 1);
        }
      }
    },

    /**
     * 上传症状附件验证
     */
    beforeUploadProblem(file) {
      const isLt20M = file.size / 1024 / 1024 < 10;
      var fileSrc = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isPDF = fileSrc === "pdf";
      const isImg =
        fileSrc === "jpg" ||
        fileSrc === "png" ||
        fileSrc === "jpeg" ||
        fileSrc === "JPG" ||
        fileSrc === "PNG" ||
        fileSrc === "JPEG";
      if (!isLt20M) {
        this.showModel("症状附件大小不能超过10MB");
      }
      if (!isPDF && !isImg) {
        this.showModel("只能上传pdf，jpg，png, jpeg格式");
      }
      return isLt20M && (isPDF || isImg);
    },
    /**
     * 症状附件成功处理
     */
    uploadProblemSuccess(response, file, fileList) {
      let data = {
        file: file,
        id: response.data.id,
      };
      this.problemFileList = this.problemFileList.concat(data);
    },
    /**
     * 症状附件移除
     */
    removeProblem(file, fileList) {
      for (let i = 0; i < this.problemFileList.length; i++) {
        if (this.problemFileList[i].file.uid == file.uid) {
          this.problemFileList.splice(i, 1);
        }
      }
    },

    /**
     * 验证是否有未上传完的文件
     */
    fileUploadCheck() {
      let uploadBill = this.$refs.upload_bill.$data.uploadFiles;
      let uploadCard = this.$refs.upload_card.$data.uploadFiles;
      let uploadProblem = this.$refs.upload_problem.$data.uploadFiles;
      let flag = true;
      if (uploadBill.length > 0) {
        flag = uploadBill.every(function (item) {
          return item.status === "success";
        });
      }
      if (uploadCard.length > 0) {
        flag = uploadCard.every(function (item) {
          return item.status === "success";
        });
      }
      if (uploadProblem.length > 0) {
        flag = uploadProblem.every(function (item) {
          return item.status === "success";
        });
      }
      if (!flag) {
        this.showModel("附件上传中，请等待");
      }
      return flag;
    },
    // 添加预约
    addQuery() {
      console.log("添加预约");
      console.log(this.reserveType);
      console.log(this.reserveReason);
      console.log("fileUploadCheck: " + this.fileUploadCheck());
      console.debug("customerID", localStorage.getItem("customerID"));
      if (this.fileUploadCheck()) {
        if (this.reservationCheck) {
          //取出附件数组中的id值
          let billFileList = [];
          let billFileListStr = "";
          this.billFileList.forEach((e) => {
            billFileList.push(e.id);
          });
          billFileListStr = billFileList.join(",");
          let cardFileList = [];
          let cardFileListStr = "";
          this.cardFileList.forEach((e) => {
            cardFileList.push(e.id);
          });
          cardFileListStr = cardFileList.join(",");
          let problemFileList = [];
          let problemFileListStr = "";
          this.problemFileList.forEach((e) => {
            problemFileList.push(e.id);
          });
          problemFileListStr = problemFileList.join(",");
          console.log("this.checkInput():", this.checkInput());
          if (this.checkInput()) {
            // 获取省市区label
            let provinceName = "";
            this.proviceList.forEach((item) => {
              if (item.provinceid == this.provinceCode) {
                provinceName = item.name;
              }
            });
            let cityName = "";
            this.cityList.forEach((item) => {
              if (item.cityid == this.cityCode) {
                cityName = item.name;
              }
            });
            let districtName = "";
            this.districList.forEach((item) => {
              if (item.areaid == this.districtCode) {
                districtName = item.name;
              }
            });
            let townName = "";
            this.townList.forEach((item) => {
              if (item.townid == this.townCode) {
                townName = item.name;
              }
            });
            this.loadingFlag = true;
            console.log("校验成功！");
            this.reservationCheck = false;
            let url = api.reservation.addBookService();
            let data = {
              vaildCode: this.verificationNum.trim(),
              CustomerBean: {
                customercode: localStorage.getItem("customerID") || "",
                smsCode: this.smsCode,
                address:
                  provinceName +
                  cityName +
                  districtName +
                  townName +
                  this.detailAddr.trim(),
                provinceID: this.provinceCode.trim(),
                cityID: this.cityCode.trim(),
                districtId: this.districtCode.trim(),
                // organizationCode:
                //   `${BASE_PATH}` === "development" || this.conditionFlag
                //     ? "66000"
                //     : this.serviceSite,
                organizationCode: this.serviceSite,
                naming: this.gender, // sir/lady
                customerName: this.name.trim(),
                email: this.email.trim(),
                phone: "", // 电话
                mobile: this.mobile.trim(), // 手机
              },
              ReserveBean: {
                reserveReason: this.reserveReason.trim(),
                // organizationCode:
                //   `${BASE_PATH}` === "development" || this.conditionFlag
                //     ? "66000"
                //     : this.serviceSite,
                organizationCode: this.serviceSite,
                reserveType: this.reserveType,
                customerReserveDate: this.customerReserveDate,
                reserveDateRange: this.reserveDateRange, // A或P
                source: "3",
              },
              ReserveDtlBean: [
                {
                  homeServiceDate: "", // 为空就可以
                  modelCode: this.modelCode, // 产品型号
                  purchaseDate: this.buyDate, // 到天就可以了
                  serialNo: this.serialNum.trim(), // 序列号
                  userTrouble: this.trouble.trim(),
                  reserveType: this.reserveType,
                  warrantyType: this.warrantyType,
                  productType: this.productType,
                  repairProperties: this.repairPropertie,
                  reserveReason: this.reserveReason,
                  addMemory: "",
                  backupBySelf: "",
                  canReplaceResume: "",
                  clearPassword: "",
                  extendWarranty: "",
                  isReset: "",
                  preRepairFee: "",
                  suggestParts: "",
                  isReturn: "", // 在页面上加一个勾选该字段的
                  //添加附件
                  billFileList: billFileListStr,
                  cardFileList: cardFileListStr,
                  problemFileList: problemFileListStr,
                },
              ],
            };
            http
              .post(url, data)
              .then((res) => {
                this.loadingFlag = false;
                this.imgsrc = getCode();
                this.reservationCheck = true;
                let mes = res.data.message;
                let data = res.data.data;
                if (res.data.stateCode === 1) {
                  this.RegisNumber = data;
                  this.detailFlag = true;
                  // setTimeout(() => {
                  //   window.location.href = api.prd
                  // }, 2000)
                  if (this.reserveType == "H") {
                    this.successQrCodeUrl = require("../assets/img/202305220001_1280_toHome.jpg");
                  }
                } else {
                  this.showModel(mes);
                }
                console.log("添加预约：", res);
              })
              .catch((error) => {
                this.loadingFlag = false;
                this.imgsrc = getCode();
                this.reservationCheck = true;
                this.showModel("预约失败，请稍后再试");
                console.log(error);
              });
          }
        }
      }
    },
    refreshImg() {
      this.imgsrc = getCode();
    },
    warrantCheck(index, code) {
      this.warrantyType = code;
      this.warrantIndex = index;
    },
    getAppointment(year) {
      console.log("reservedate:", year);
      let url = api.reservation.queryDateRange();
      return new Promise(function (resolve, reject) {
        http({
          method: "get",
          url: url,
          params: {
            reservedate: year,
            stationcode: "",
          },
          // data: ''
        })
          .then((res) => {
            resolve(res.data);
          })
          .catch(function (error) {
            console.log(error);
          });
      });
    },
    checkTime(val) {
      let newval = val.substr(0, 2);
      if (newval <= 12) {
        return "A";
      } else {
        return "P";
      }
    },
    async seletWeekDay(index, year) {
      this.weekIndex = index;
    },
    selectDay(index) {
      this.dayIndex = index;
      if (index === 0) {
        this.customerReserveDate = `${this.weekList[this.weekIndex].year
          } 08:00:00`;
        this.reserveDateRange = "A";
      } else if (index === 1) {
        this.customerReserveDate = `${this.weekList[this.weekIndex].year
          } 14:00:00`;
        this.reserveDateRange = "P";
      }
    },
    radioSelect(sex, index) {
      this.gender = sex;
      this.misterFlag = index;
    },
    checkFun() {
      if (this.productType && this.reserveReason) {
        console.log("this.productType:", this.productType);
        console.log("this.serviceType:", this.serviceType);
        this.checkA = !this.checkA;
        this.formPart = !this.formPart;
        return true;
      } else {
        this.$toast({
          show: true,
          message: "请选择预约信息!",
          position: "top",
          during: 3000,
        });
        return false;
      }
    },
    selectProduct(index, type, category) {
      this.productType = type;
      this.productIndex = index;
      let attrStr = "serviceType" + Number(index + 1);
      this.serviceType = this[attrStr];
      this.repairPropertie = "";
      this.reserveReason = "";
      this.serviceIndex = null;
      this.checkA = false;
      this.formPart = false;
      this.productCategory = category;
    },
    selectService(index, serviceType) {
      console.log("reasonCode:", serviceType);
      this.repairPropertie = serviceType.properties;
      this.reserveReason = serviceType.reasonCode;
      this.serviceIndex = index;
      this.isPickUp = serviceType.isPickUp;
      this.checkA = false;
      this.formPart = false;
    },
    getSite() {
      this.ASCList.forEach((item) => {
        if (item.ascid === this.serviceSite) {
          this.serviceSiteName = item.ascmame;
          this.serviceTelephone = item.telephone;
          return false;
        }
      });
    },
    getSelectVal(res) {
      this.proviceList = res;
      this.proviceList.forEach((a, b) => {
        if (this.provinceCode === a.childName) {
          let rets = this.initAddress(this.provinceCode);
          this.cityList = rets;
          this.cityList.forEach((item, index) => {
            if (this.cityCode === item.childName) {
              let rets2 = this.initAddress(this.cityCode);
              this.districList = rets2;
            }
          });
        }
      });
    },

    /**
     * 初始化获取省份
     */
    findProvince() {
      let url = api.reservation.findProvince();
      http.get(url).then((res) => {
        let data = res.data;
        if (data.stateCode === 1) {
          let provinceList = data.data;
          this.proviceList = provinceList;
        } else {
          this.proviceList = [];
        }
      });
    },

    /**
     * 选择省份获取城市
     */
    selectProvince() {
      let url = api.reservation.findCity() + "/" + this.provinceCode;
      http.get(url).then((res) => {
        let data = res.data;
        if (data.stateCode === 1) {
          let cityForm = data.data;
          this.cityList = cityForm;
        } else {
          this.cityList = [];
        }
        this.districList = [];
        this.townList = [];
        this.ASCList = [];
        this.serviceSite = "default";
        this.cityCode = "default";
        this.districtCode = "default";
        this.townCode = "default";
      });
    },

    /**
     * 选择城市获取乡区
     */
    selectCity() {
      let url =
        api.reservation.findDistinct() +
        "/" +
        this.cityCode +
        "?t=" +
        new Date().getTime();
      http.get(url).then((res) => {
        console.log(res.data);
        let data = res.data;
        if (data.stateCode === 1) {
          let districtForm = data.data;
          this.districList = districtForm;
        } else {
          this.districList = [];
        }
        this.townList = [];
        this.ASCList = [];
        this.serviceSite = "default";
        this.townCode = "default";
        this.districtCode = "default";
      });
    },

    /**
     * 选择乡区获取城镇
     */
    selectDistrict() {
      let url = api.reservation.findTown() + "/" + this.districtCode;
      //获取城镇
      http.get(url).then((res) => {
        let data = res.data;
        let townForm = data.data;
        this.townList = townForm;
        this.townCode = "default";
        this.serviceSite = "default";
        this.serviceSiteName = "";
        this.serviceTelephone = "";
        this.ASCList = [];
        if (this.townList.length == 0) {
          //无城镇数据，在乡区选择时获取维修站
          this.getAsc();
        }
      });
    },

    /**
     * 获取维修站
     */
    getAsc() {
      let params = {
        provinceId: this.provinceCode,
        cityId: this.cityCode,
        districtId: this.districtCode,
        townId: this.townCode === "default" ? "" : this.townCode,
        serviceCategory: this.productTypes[this.productIndex].serviceCategory,
      };
      var urlParams = Object.keys(params)
        .map(function (key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
      console.log(urlParams);
      let url = api.reservation.findAsc() + "?" + urlParams;
      http.get(url).then((res) => {
        console.log(res.data);
        let data = res.data;
        let ascForm = data.data;
        // this.ASCList = ascForm.filter(item => item.ascCode !== 'FF012' && item.ascCode !== 'FF013' && item.ascCode !== 'FF015')
        this.ASCList = ascForm;
        if (this.ASCList.length > 0) {
          this.serviceSite = this.ASCList[0].ascid;
          this.serviceSiteName = this.ASCList[0].ascmame;
          this.serviceTelephone = this.ASCList[0].telephone;
        } else {
          this.serviceSite = "default";
          this.serviceSiteName = "";
          this.serviceTelephone = "";
        }
      });
    },

    getCondition() {
      this.conditionFlag = Condition(this);
    },
    /**
     * 获取上门日期
     */
    getHomePikcDate() {
      let url = api.reservation.getSystemTime();
      http({
        method: "get",
        url: url,
        params: {
          dayNum: 14,
          split: "-",
          containNow: false,
        },
      }).then((res) => {
        this.weekList = res.data.data.list;
        console.log(res.data.data.list);
        console.log("this.week:", this.weekList);
      });
    },

    /**
     * 获取会员信息
     */
    getPersonalDetails() {
      let userInfo = JSON.parse(localStorage.getItem("user_details") || "null");
      let mobile = userInfo ? userInfo.telephone : "";
      let userAlias = userInfo ? (userInfo.realName || userInfo.userAlias) : "";
      this.name = userAlias;
      this.mobile = mobile;
    },

    /**
     * 获取已注册产品列表
     */
    getRegPorductList() {
      let url = api.member.productRegistrationHistory();
      http({
        method: "POST",
        url: url,
        data: {
          idToken: localStorage.getItem("oidc_id_token") || "",
          page: 0,
          pageSize: 50
        },
      }).then((res) => {
        console.info(res.data.data.productRegList)
        this.regProductDataList = res.data.data.productRegList
      });
    },

    /**
     * 点击选择已注册产品
     */
    handleRegProduct() {
      let productList = this.regProductDataList || []
      console.info(productList)
      if (productList.length == 0) {
        this.showModel("您暂无已注册产品");
        return;
      }
      this.regProductFlag = true
    },

    /**
     * 选择已注册产品
     */
    selectRegPorduct(productModel, serialNumber) {
      console.info(productModel, serialNumber);
      // 231207add 商显必须 FW- 开头录入
      if (this.productCategory == 'stv') {
        if (productModel != '' && productModel.substring(0, 3) != 'FW-') {
          this.modelCode = "";
          this.$toast({
            show: true,
            message: "请选择FW-开头的产品型号",
            position: "top",
            during: 3000,
          });
          return;
        }
      }
      this.checkProductTypeAndCode(productModel, result => {
        if (!result) {
          this.modelCode = "";
          this.$toast({
            show: true,
            message: this.productCategory === "tv" ? "请输入电视机型号" : "输入的产品型号与产品类别不匹配",
            position: "top",
            during: 3000,
          });
        } else {
          this.modelCode = productModel;
          this.serialNum = serialNumber;
          this.regProductFlag = false;
        }
      });
    },
    /**
     * 校验输入的产品型号和产品类别是否一致
     * @param {*} mode 
     */
    checkProductTypeAndCode(mode, callback) {
      let result = false;
      //只校验液晶电视，家庭影院， 显示器，电视遥控器的产品型号
      if (this.productCategory != "tv" && this.productCategory != "audio") {
        result = true;
        callback(result);
        return;
      }
      let url = api.reservation.getProductType();
      http({
        method: "GET",
        url: url,
        params: {
          method: 'findByEnName',
          enName: mode
        },
      })
        .then((res) => {
          if (JSON.stringify(res.data.returnData) === "{}") {
            callback(result);
            return;
          }
          //category用/区分最后一层是产品类别
          let strNumber = res.data.returnData.Data.category.lastIndexOf('/');
          let productType = res.data.returnData.Data.category.substring(strNumber + 1);
          if (productType == this.productCategory) {
            result = true;
          }
          console.log("产品类别：", productType);
          callback(result);
          return;
        })
        .catch(function (error) {
          console.log(error);
          callback(result);
          return;
        });
    },
    homePageAA() {
      console.log('AA', this.$route.path, this.$route.name);
      window.digitalData = {
        page: {
          pageInfo: {
            pageURL: window.location.href,
            pageName: 'best:' + this.$route.name,	//页面名称，必填变量
            pageTitle: 'best:' + this.$route.name,
            siteSection: "best"	//网站区域，必填
          }
        }
      };
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.getCondition();
      console.log(
        "BASE_PATH:",
        `${BASE_PATH}` === "development" || this.conditionFlag
          ? "66000"
          : "this.serviceSite"
      );
    });


  },

  beforeCreate() {
    console.log("create : " + isMobileDevice());

    if (isMobileDevice()) {
      console.log("is mobile device");
      window.location = "/mobilesite/index.html#/toHome";
    }
  },

  async created() {
    document.getElementById("app").addEventListener(
      "click",
      (event) => {
        if (this.modeSpread) {
          event.stopPropagation();
        } else {
          this.modelulFlag = false;
        }
      },
      false
    );
    this.serviceType = this.serviceType1;
    this.refreshImg();
    this.getHomePikcDate();
    // console.log("this.initAddress('China_StateNode.json'):", await this.initAddress('China_StateNode.json'))
    // this.proviceList = await this.initAddress("China_StateNode.json");
    this.findProvince();
    this.getPersonalDetails();
    this.getRegPorductList();
    this.homePageAA();
  },
};
</script>
<style>
@import url("../assets/css/common.css");
@import url("../assets/css/index.css");

.reg-product {
  text-decoration: underline #00b0ec;
  color: #00b0ec;
  font-size: 15px;
  margin-top: 10px;
  cursor: pointer;
}

.select-wrap2 {
  width: 53rem;
}

.select-wrap select {
  width: 11rem;
  border: 1px solid rgba(216, 221, 225, 1);
  height: 56px;
  line-height: 56px;
  padding-left: 10px;
  font-size: 15px;
  color: #576371;
  overflow-y: scroll;
}

.vercode {
  display: inline-block;
  line-height: 50px;
  width: 124px;
  height: 52px;
  text-align: center;
  color: white;
  font-size: 15px;
  background: #0190e1;
  cursor: pointer;
}

.vercode_disable {
  display: inline-block;
  line-height: 50px;
  width: 124px;
  height: 52px;
  text-align: center;
  color: white;
  font-size: 15px;
  background: #a4a4a4;
  cursor: pointer;
}

.qrcode-img {
  width: 150px;
  height: 150px;
}
</style>
